"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const Tag = (0, react_1.forwardRef)(({ children, className, large, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("span", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-tag', large && 'usa-tag--big', className), ...props, children: children }));
});
exports.default = Tag;
